import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { LeadershipPage } from './pages/LeadershipPage';
export function App() {
  return <div className="min-h-screen bg-avm-bg text-avm-text font-sans selection:bg-avm-accent selection:text-avm-bg" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/leadership" element={<LeadershipPage data-id="element-7" />} data-id="element-6" />
        </Routes>
      </main>
      <Footer data-id="element-8" />
    </div>;
}